<template>
    <div class="policies">
        <div class="policiesBox">
            <div class="policiesHead">
                <div>
                    <span class="title">政策法规</span>
                    <span class="describe">政策为民，法规护航</span>
                </div>
                <div class="more" @click="onMore()">更多 +</div>
            </div>
            <div class="policiesContent">
                <div  v-for="(item, index) in policiesRegulations"  :key="index">
                    <div class="notificationBox"  >
                        <div class="dot"></div>
                        <div :class="['Title', selectedRow == index ? 'selectRow'  : '']" @click="onJumpLink(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div>
            </div>


            
        </div>

        <div class="downloadCenter">
            <div class="downloadCenterHead">
                <span class="title">下载中心</span>
                <span class="describe">一键下载，轻松获取</span>
            </div>
            <div class="policiesContent">
                <div  v-for="(item, index) in downloadItems"  :key="index">
                    <div class="notificationBox"  >
                        <div class="dot"></div>
                        <div :class="['Title', selectedRowTwo == index ? 'selectRow'  : '']" @click="onJumpLink2(item, index)">{{item.title}}</div>
                        <div class="time">
                            {{item.createDate}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="contentTop">
                <div class="contentTopLeft" >
                    <div class="contentTopLeftTitle" >培训证书转出证明模板</div>
                    <div class="contentTopLeftButton" @click="onJumpDetailPage('')">
                        <span style="font-size: 14px;">模板下载</span>
                        <img src="../../assets/img/newHome/uploadLogo.png" style="margin-left:10px ;width: 22px;" />
                    </div>
                </div>

                <div class="contentTopRight" >
                    <div class="contentTopRightTitle" >会员登记表</div>
                    <div class="contentTopRightButton" @click="onJumpDetailPage('会员登记表')" >
                        <span style="font-size: 14px;">模板下载</span>
                        <img src="../../assets/img/newHome/uploadLogo.png" style="margin-left:10px ;width: 22px;" />
                    </div>
                </div>
            </div>


            <div class="contentBottom">
                <div class="contentBottomLeft" >
                    <div class="contentBottomLeftTitle" >系统操作手册</div>
                    <div class="contentBottomLeftButton" @click="onJumpDetailPage('')">
                        <span style="font-size: 14px;">手册下载</span>
                        <img src="../../assets/img/newHome/uploadLogoTwo.png" style="margin-left:10px ;width: 22px;" />
                    </div>
                </div>

                <div class="contentBottomRight" >
                    <div class="contentBottomRightTitle" >会费收取及管理办法</div>
                    <div class="contentBottomRightButton" @click="onJumpDetailPage('会费收取及管理办法')">
                        <span style="font-size: 14px;">模板下载</span>
                        <img src="../../assets/img/newHome/uploadLogo.png" style="margin-left:10px ;width: 22px;" />
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import * as dayjs from 'dayjs';
import { prefixedUrlAsset } from '@/utils/constants';
export default {
    props: {
        policiesRegulations: {
            type: Array,
            default: () => {}
        },
        downloadItems: {
            type: Array,
            default: () => {}
        },
    },
    components: {},
    computed: {
    
    },
    data() {
        return {
            selectedIndex: 0,
            dynamicList:[],
            informList:[],
            industryInfoList:[],
            selectedRow: null,
            selectedRowTwo: null,
        
        };
    },
 
    created() {
    },
    mounted() {
    },
    methods: {
        onJumpLink(item, index){
            this.selectedRow=index
            window.open(`/#/detail/`+item.id);
        },
        onJumpLink2(item, index){
            this.selectedRowTwo=index
            window.open(`/#/detail/`+item.id);
        },
        onMore(){
            window.open(`/#/list/4/政策法规`);
        }
        
    },
};
</script>

<style lang="less">
    .policies{
        padding: 10px 10%;
        display: flex;
        background: #F5F5F5;
        .policiesBox{
            width: 50%;
            margin-right: 20px;
            background: #fff;
            padding: 16px;
            .policiesHead{
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px solid #E4E7ED;
                padding-bottom: 2px;
                .title{
                    font-weight: bold;
                    font-size: 24px;
                    color: #000000;
                    border-bottom: 4px solid #00A287;
                }
                .describe{
                    font-weight: bold;
                    font-size: 16px;
                    color: #00A287;
                    margin-left: 16px;
                }
                .more{
                    font-size: 14px;
                    color: #9AA6B5;
                    cursor: pointer;
                    &:hover {
                        color: #00A287;
                        font-weight: bold;
                    }
                }
            }
            .policiesContent{
                margin-top: 10px;
                .notificationBox{
                    display: flex;
                    align-items: center;
                    justify-content:space-between; 
                    padding: 5px 0; 
                    .dot{
                        width: 8px;
                        height: 8px;
                        background: #0BA58C;
                        border-radius: 50%;
                    }      
                    .Title{
                        margin-left: 16px;
                        flex: 1;
                        display: -webkit-box;
                        word-break: break-all;             
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        &:hover {
                            color: #00A287;
                        }
                    }
                    .time{
                        width: 100px;
                        margin-left: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9AA6B5;
                        text-align: right;
                    }
                    .selectRow{
                        color: #00A287
                    }

                }
            }
            
            
        }

        .downloadCenter{
            width: 50%;
            background: #fff;
            padding: 16px;
            .downloadCenterHead{
                align-items: center;
                border-bottom: 2px solid #E4E7ED;
                padding-bottom: 2px;
                .title{
                    font-weight: bold;
                    font-size: 24px;
                    color: #000000;
                    border-bottom: 4px solid #00A287;
                }
                .describe{
                    font-weight: bold;
                    font-size: 16px;
                    color: #00A287;
                    margin-left: 16px;
                }
            }
            .policiesContent{
                margin-top: 10px;
                .notificationBox{
                    display: flex;
                    align-items: center;
                    justify-content:space-between; 
                    padding: 5px 0; 
                    .dot{
                        width: 8px;
                        height: 8px;
                        background: #0BA58C;
                        border-radius: 50%;
                    }      
                    .Title{
                        margin-left: 16px;
                        flex: 1;
                        display: -webkit-box;
                        word-break: break-all;             
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        font-size: 14px;
                        color: #000000;
                        cursor: pointer;
                        &:hover {
                            color: #00A287;
                        }
                    }
                    .time{
                        width: 100px;
                        margin-left: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #9AA6B5;
                        text-align: right;
                    }
                    .selectRow{
                        color: #00A287
                    }

                }
            }
            .contentTop{
                display: flex;
                margin-top: 46px;
                .contentTopLeft{
                    width: 60%;
                    height: 160px;
                    margin-right: 16px;
                    background: linear-gradient( 225deg, #F5F5F5 0%, #CCECE7 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .contentTopLeftTitle{
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                    }
                    .contentTopLeftButton{
                        width: 136px;
                        height: 40px;
                        background: #13A88F;
                        border-radius: 20px 20px 20px 20px;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        cursor: pointer;
                    }
                }
                .contentTopRight{
                    width: 40%;
                    height: 160px;
                    background: linear-gradient( 225deg, #F5F5F5 0%, #CCECE7 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .contentTopRightTitle{
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                    }
                    .contentTopRightButton{
                        width: 136px;
                        height: 40px;
                        background: #13A88F;
                        border-radius: 20px 20px 20px 20px;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        cursor: pointer;
                    }
                }
            }
            .contentBottom{
                display: flex;
                margin-top: 16px;
                .contentBottomLeft{
                    width: 40%;
                    height: 160px;
                    margin-right: 16px;
                    background: linear-gradient( 315deg, #F5F5F5 0%, #13A88F 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    .contentBottomLeftTitle{
                        font-weight: bold;
                        font-size: 16px;
                        color: #fff;
                    }
                    .contentBottomLeftButton{
                        width: 136px;
                        height: 40px;
                        background: #fff;
                        border-radius: 20px 20px 20px 20px;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #13A88F;
                        cursor: pointer;
                    }
                }
                .contentBottomRight{
                    width: 60%;
                    height: 160px;
                    background: linear-gradient( 225deg, #F5F5F5 0%, #CCECE7 100%);
                    border-radius: 16px 16px 16px 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .contentBottomRightTitle{
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                    }
                    .contentBottomRightButton{
                        width: 136px;
                        height: 40px;
                        background: #13A88F;
                        border-radius: 20px 20px 20px 20px;
                        margin-top: 24px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        cursor: pointer;
                    }
                }
            }
            
        }
       
        
    }

    
    </style>